import React from 'react';
import { transactions as types } from '../../../../../../types';
import { Root, ColStyled, RowStyled } from './styled';

const TopUpInfo = ({ curData }: { curData: types.TTransactions }) => {
    return (
        <Root>
            <RowStyled>
                <ColStyled>
                    <span>User</span>
                    <span>{curData.nexId}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Account type</span>
                    <span></span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Top Up amount</span>
                    <span>{curData.amount}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Balance</span>
                    <span>{curData.meta.walletBalance}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Turnover</span>
                    <span>{curData.meta.turnover}</span>
                </ColStyled>
            </RowStyled>
        </Root>
    );
};

export default TopUpInfo;
